import SetPasswordPageContainer from "./SetPasswordPageContainer";

export default SetPasswordPageContainer;
